import { useContext } from "react";
import { TourContext } from "./TourContext";

export const useTour = () => useContext(TourContext);
